import styled from "@emotion/styled";
import { fontPretendard } from "@teamsparta/design-system/dist/font/font";
import { DESKTOP } from "@/themes/device";

export const ModalBackground = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 100000000;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
`;

export const Modal = styled.article`
  font-family: ${fontPretendard};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 312px;
  height: 444px;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  padding: 8px;
  justify-content: center;
  animation: fadein 1s;
  -moz-animation: fadein 1s; /* Firefox */
  -webkit-animation: fadein 1s; /* Safari and Chrome */
  -o-animation: fadein 1s;
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-moz-keyframes fadein {
    /* Firefox */
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes fadein {
    /* Safari and Chrome */
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-o-keyframes fadein {
    /* Opera */
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  ${DESKTOP} {
    height: 684px;
    width: 480px;
  }
`;

export const ModalClose = styled.button`
  border: none;
  background-color: transparent;
  position: absolute;
  cursor: pointer;
  top: 15px;
  right: 25px;
  ${DESKTOP} {
    top: 16px;
    right: 31px;
  }
`;

export const DesktopCloseImg = styled.div`
  display: none;
  ${DESKTOP} {
    position: relative;
    display: initial;
    width: 20px;
    height: 20px;
  }
`;

export const MobileCloseImg = styled.div`
  position: relative;
  width: 14px;
  height: 14px;
  ${DESKTOP} {
    display: none;
  }
`;

export const Cta = styled.div`
  position: absolute;
  bottom: 20px;
  z-index: 100000000;
  ${DESKTOP} {
    bottom: 30px;
  }
  button {
    height: 50px;
    width: 250px;
    font-size: 14px;
    padding: 16.5px 0;
    ${DESKTOP} {
      height: 70px;
      width: 385px;
      font-size: 20px;
      padding: 25.5px 0;
    }
  }
`;
